import { VNode } from 'preact'
import { PreviewElementType, PreviewNodeProps, PreviewProps } from './interfaces'

export function previewProps(type: PreviewElementType, id?: string, draggable?: boolean): PreviewProps {
  return {}
}

export function makePreviewNode(
  node: VNode<PreviewNodeProps>,
  { previewInteractive }: { previewInteractive?: boolean },
) {
  // noop
}
